import { useMutation, useQueryClient } from '@tanstack/react-query';
import QualAPI from 'utils/QualAPI';
import { upgradeKeys } from './queries';
import { subscriptionKeys } from '../subscriptions/queries';

/**
 * Hook to upgrade a subscription to a different plan
 * @returns {Object} Mutation object with mutate function
 * 
 * Response payload format:
 * {
 *   "id": 26,
 *   "user_id": 64,
 *   "current_period_end": "2020-01-12T12:11:27.000Z",
 *   "status": "active",
 *   "cancel_at_period_end": false,
 *   "quantity": 1,
 *   "plan": {
 *     "id": 4,
 *     "amount": "21600.0",
 *     "interval": "year"
 *   }
 * }
 */
export function useUpgradeSubscription() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (planId) => QualAPI.createUpgrade(planId).then(response => response.data),
    onSuccess: (updatedSubscription) => {
      // Update the cache directly with the response data
      // The subscriptions endpoint returns an array, so wrap the updated subscription
      queryClient.setQueryData(subscriptionKeys.all, {
        subscriptions: [updatedSubscription]
      });
      
      // Invalidate upgrades since the available upgrades may have changed
      queryClient.invalidateQueries({ queryKey: upgradeKeys.all });
    },
    onError: (error) => {
      console.error('Upgrade subscription failed:', error);
    }
  });
}